import { render, staticRenderFns } from "./BindSchool.vue?vue&type=template&id=e4774582&"
import script from "./BindSchool.vue?vue&type=script&lang=ts&"
export * from "./BindSchool.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports